module.exports = __webpack_public_path__ + "img/neotag_unit_white-01.5248a6d2.svg";